export const SAVE_FORM_DATA_REQUEST = "SAVE_FORM_DATA_REQUEST";
export const SAVE_FORM_DATA_SUCCESS = "SAVE_FORM_DATA_SUCCESS";
export const SAVE_FORM_DATA_FAILURE = "SAVE_FORM_DATA_FAILURE";
